import { createAsyncThunk } from '@reduxjs/toolkit';
import { updateIdleTimeoutMinutes } from './user-summary-slice';
import { IdleSession } from '../../utils/idleSession';

export const UpdateIdleTimeout = createAsyncThunk(
    'userSummary/updateIdleTimeout',
    async (idleTimeoutMinutes: number, { dispatch, getState }: any) => {
        const axios = getState().core.axios;
        const response = await axios.put('/api/Users/idleTimeout', {
            idleTimeoutMinutes,
        });
        const isSaved = response?.status === 200;
        if (isSaved) {
            dispatch(updateIdleTimeoutMinutes(idleTimeoutMinutes));
            IdleSession.recordActivity(true);
        }
        return isSaved;
    }
);
